export const formatUser = user => {
  if (user) {
    let formatted = `${user.lastName}, ${user.firstName}`;
    formatted += user.middleName ? " " + user.middleName : "";
    formatted += user.credential ? " " + user.credential.name : "";
    return formatted;
  }
};
